import axios from 'axios';
import config from './config';

// Fetch all notifications
export const fetchNotifications = async () => {
  const response = await axios.get(`${config.API_BASE_URL}/Notifications`);
  return response.data;
};

// Fetch notifications by type (e.g., registration-success)
export const fetchNotificationByType = async (type) => {
  const response = await axios.get(`${config.API_BASE_URL}/Notifications/type/${type}`);
  return response.data;
};

// ✅ NEW: Mark a single notification as read
export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await axios.put(
      `${config.API_BASE_URL}/Notifications/${notificationId}/mark-read`,
      {},
      { headers: { 'Content-Type': 'application/json' } }
    );
    
    return response.status === 200;
  } catch (error) {
    console.error('Error marking notification as read:', error);
    return false;
  }
};

// ✅ NEW: Mark all notifications as read for a user
export const markAllNotificationsAsRead = async (userId) => {
  try {
    const response = await axios.put(
      `${config.API_BASE_URL}/Notifications/user/${userId}/mark-all-read`,
      {},
      { headers: { 'Content-Type': 'application/json' } }
    );
    
    return response.status === 200;
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    return false;
  }
};

// ✅ NEW: Get unread notification count for a user
export const getUnreadNotificationCount = async (userId) => {
  try {
    const response = await axios.get(`${config.API_BASE_URL}/Notifications/user/${userId}/unread-count`);
    return response.data.unreadCount || 0;
  } catch (error) {
    console.error('Error getting unread count:', error);
    return 0;
  }
};
